import React, { useState } from 'react';
import axios from 'axios';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

// Import the logo image
import logoImage from '../assets/images/logo.jpg'; // Adjust the path according to your project structure

const SDSRLedger = () => {
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [summaryData, setSummaryData] = useState([]);
    const [message, setMessage] = useState('');

    const handleGenerate = async () => {
        if (!fromDate || !toDate) {
            setMessage('Please select both From and To dates');
            return;
        }

        try {
            const response = await axios.post('https://chaman.gob.pk/eac_backend/s-dsr.php', {
                action: 'get_summary',
                from_date: fromDate,
                to_date: toDate
            });

            if (response.data.status === 'success') {
                setSummaryData(response.data.data);
                setMessage('');
            } else {
                setMessage(response.data.message || 'Error fetching data');
            }
        } catch (error) {
            setMessage('An error occurred while fetching the data');
            console.error(error);
        }
    };

    const exportToPDF = () => {
        const doc = new jsPDF('landscape');
        const pageWidth = doc.internal.pageSize.getWidth();

        // Add Logo Image (Centered)
        const imageWidth = 0.80 * 25.4; // Adjust to your logo size
        const imageHeight = 0.6 * 25.4; // Adjust to your logo size
        const xCenter = (pageWidth - imageWidth) / 2;
        doc.addImage(logoImage, 'JPEG', xCenter, 10, imageWidth, imageHeight);

        // Main Heading (Centered, Bold, and Dark Color)
        doc.setFontSize(21.5);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(0, 0, 0); // Dark color
        doc.text('OFFICE OF THE DEPUTY COMMISSIONER CHAMAN', pageWidth / 2, 37, { align: 'center' });

        // Add Date Range
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 0);
        doc.text(`Date From: ${fromDate || 'N/A'}`, pageWidth - 60, 15);
        doc.text(`Date To: ${toDate || 'N/A'}`, pageWidth - 60, 22);

        // Table Headers
        const headers = [["S.No.", "Token ID", "Subject", "Date", "Location", "Timings", "Approx. Strength", "Prominent Speakers", "Hate Speech", "Security Arrangements", "Special Activity"]];

        // Table Data
        const tableData = summaryData.map((entry, index) => [
            (index + 1).toString(),
            entry.token_id,
            entry.subject,
            entry.dated,
            entry.location,
            entry.timings,
            entry.approximate_strength,
            entry.prominent_speakers,
            entry.hate_speech,
            entry.security_arrangements,
            entry.special_activity
        ]);

        // Generate the table
        doc.autoTable({
            head: headers,
            body: tableData,
            startY: 45,
            theme: 'grid',
            headStyles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] },
            styles: {
                fontSize: 10,
                textColor: [0, 0, 0],
            },
            columnStyles: {
                0: { halign: 'center' },
            },
        });

        doc.save('S-DSR_Ledger_Summary.pdf');
    };

    return (
        <div className="sdsr-ledger-container">
            {/* <h2>S-DSR Ledger</h2> */}
            {message && <p className="message">{message}</p>}

            <div className="date-range">
                <div className="date-input">
                    {/* <label id='ledgerl1'>From Date</label> */}
                    <input
                        type="date"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                    />
                </div>
                <div className="date-input">
                    {/* <label id='ledgerl2'>To Date</label> */}
                    <input
                        type="date"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                    />
                </div>
                <button id='ledgerb' onClick={handleGenerate}>Generate</button>
                <button id='ledgerb' onClick={exportToPDF}>Export</button>
            </div>

            {summaryData.length > 0 && (
                <div className="summary-table">
                    {/* <h3>Summary</h3> */}
                    <table id='st'>
                        <thead>
                            <tr>
                                <th>Token ID</th>
                                <th>Subject</th>
                                <th>Date</th>
                                <th>Location</th>
                                <th>Timings</th>
                                <th>Approx. Strength</th>
                                <th>Prominent Speakers</th>
                                <th>Hate Speech</th>
                                <th>Security Arrangements</th>
                                <th>Special Activity</th>
                            </tr>
                        </thead>
                        <tbody>
                            {summaryData.map((item) => (
                                <tr key={item.token_id}>
                                    <td>{item.token_id}</td>
                                    <td>{item.subject}</td>
                                    <td>{item.dated}</td>
                                    <td>{item.location}</td>
                                    <td>{item.timings}</td>
                                    <td>{item.approximate_strength}</td>
                                    <td>{item.prominent_speakers}</td>
                                    <td>{item.hate_speech}</td>
                                    <td>{item.security_arrangements}</td>
                                    <td>{item.special_activity}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {/* <button onClick={exportToPDF}>Export to PDF</button> */}
                </div>
            )}
        </div>
    );
};

export default SDSRLedger;
